/* VIP Sale 2026 – vip-delivery.js (Eigentümer: T4, Stand 19.10.2026)
   Wunschliefertermin im Warenkorb (Fallback zur Checkout-Extension „vip-wunschtermin“).
   - Baut die Radio-Liste in [data-vip-delivery-options] aus window.VIP_CONFIG.delivery.options (vip-config.liquid).
   - Auswahl → VIP.updateCart({attributes:{Wunschtermin: value}}); „Sofortige Lieferung“ sendet '' (Attribut entfernen).
   - Idempotent: Snippet wird vom Theme bei jeder Warenkorb-Änderung neu gerendert (Drawer-Footer / #MainCart-…);
     Re-Init über document 'vip:cart' (vip-core.js), zusätzlich 'cart:updated' und DOMContentLoaded.
   - Blendet sich aus, wenn window.VIP_CONFIG.delivery.mode === 'checkout' (Liquid-Flag im Snippet hat Vorrang).
   Eingebunden in layout/theme.liquid (<head>, defer, nach vip-core.js). */
(function () {
  'use strict';
  if (window.VIP_DELIVERY && window.VIP_DELIVERY.__loaded) return;

  var SELECTOR = '[data-vip-delivery]';
  var seq = 0;

  function cfg() {
    var c = (window.VIP && window.VIP.config) || window.VIP_CONFIG || {};
    return c.delivery || {};
  }
  function attrKey() { return cfg().attribute || 'Wunschtermin'; }
  function options() {
    return (cfg().options || []).filter(function (o) { return o && o.key && o.label; });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Aktueller Attributwert: bevorzugt aus dem zuletzt bekannten Warenkorb (VIP.cart), sonst aus dem Markup. */
  function currentValue(root) {
    var cart = window.VIP && window.VIP.cart;
    var key = attrKey();
    if (cart && cart.attributes && Object.prototype.hasOwnProperty.call(cart.attributes, key)) {
      return cart.attributes[key] || '';
    }
    return root.getAttribute('data-vip-current') || '';
  }
  function keyForValue(value) {
    var opts = options(), i;
    if (value) {
      for (i = 0; i < opts.length; i++) if (opts[i].value && opts[i].value === value) return opts[i].key;
    }
    for (i = 0; i < opts.length; i++) if (opts[i].value === null || opts[i].value === undefined || opts[i].value === '') return opts[i].key;
    return opts.length ? opts[0].key : 'now';
  }
  function optionByKey(key) {
    var opts = options();
    for (var i = 0; i < opts.length; i++) if (opts[i].key === key) return opts[i];
    return null;
  }

  function setSelected(root, key) {
    var labels = root.querySelectorAll('.vip-delivery__option');
    for (var i = 0; i < labels.length; i++) {
      var input = labels[i].querySelector('input');
      var on = !!input && input.value === key;
      labels[i].classList.toggle('is-selected', on);
      if (input) input.checked = on;
    }
    var opt = optionByKey(key);
    var note = root.querySelector('[data-vip-delivery-note]');
    if (note) note.hidden = !(opt && opt.value);
  }
  function setBusy(root, busy) {
    root.setAttribute('aria-busy', busy ? 'true' : 'false');
    var inputs = root.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) inputs[i].disabled = !!busy;
  }
  function showError(root, msg) {
    var el = root.querySelector('[data-vip-delivery-error]');
    if (!el) return;
    if (msg) { el.textContent = msg; el.hidden = false; } else { el.textContent = ''; el.hidden = true; }
  }

  function fallbackUpdate(attributes) {
    var r = (window.VIP && window.VIP.routes && window.VIP.routes()) || {};
    var url = (r.update || '/cart/update') + '.js';
    return window.fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ attributes: attributes })
    }).then(function (res) { return res.json(); });
  }

  function onChange(root, key) {
    var opt = optionByKey(key);
    if (!opt) return;
    var value = opt.value ? String(opt.value) : '';          // '' = Attribut entfernen (Sofortige Lieferung)
    var attributes = {};
    attributes[attrKey()] = value;

    showError(root, null);
    setBusy(root, true);
    var p = (window.VIP && typeof window.VIP.updateCart === 'function')
      ? window.VIP.updateCart({ attributes: attributes })
      : fallbackUpdate(attributes);

    p.then(function () {
      // Normalfall: das Theme hat den Footer neu gerendert, dieser Knoten ist bereits ersetzt (Re-Init über vip:cart).
      // Falls nicht (kein Re-Render), Zustand im bestehenden Knoten nachziehen.
      if (document.body.contains(root)) {
        root.setAttribute('data-vip-current', value);
        setSelected(root, key);
        setBusy(root, false);
      }
    }).catch(function (e) {
      console.warn('[VIP] Wunschtermin konnte nicht gespeichert werden', e);
      if (document.body.contains(root)) {
        setBusy(root, false);
        setSelected(root, keyForValue(currentValue(root)));
        showError(root, 'Die Auswahl konnte gerade nicht gespeichert werden. Bitte versuch es noch einmal.');
      }
    });
  }

  function init(root) {
    if (!root || root.getAttribute('data-vip-ready') === '1') return;
    if (cfg().mode === 'checkout') { root.hidden = true; root.setAttribute('data-vip-ready', '1'); return; }
    var list = root.querySelector('[data-vip-delivery-options]');
    var opts = options();
    if (!list || !opts.length) { root.hidden = true; root.setAttribute('data-vip-ready', '1'); return; }

    var name = 'vip-wunschtermin-' + (++seq);
    var selectedKey = keyForValue(currentValue(root));
    var html = '';
    for (var i = 0; i < opts.length; i++) {
      var o = opts[i], id = name + '-' + esc(o.key), on = o.key === selectedKey;
      html += '<label class="vip-delivery__option' + (on ? ' is-selected' : '') + '" for="' + id + '">' +
        '<input class="vip-delivery__input" type="radio" id="' + id + '" name="' + name + '" value="' + esc(o.key) + '"' + (on ? ' checked' : '') + '>' +
        '<span class="vip-delivery__radio" aria-hidden="true"></span>' +
        '<span class="vip-delivery__label">' + esc(o.label) + '</span>' +
        '</label>';
    }
    list.innerHTML = html;
    root.setAttribute('data-vip-ready', '1');
    setSelected(root, selectedKey);

    list.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('input[type="radio"]')) onChange(root, t.value);
    });
  }

  function initAll() {
    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  document.addEventListener('vip:cart', function () { initAll(); });
  document.addEventListener('cart:updated', function () { setTimeout(initAll, 0); });
  document.addEventListener('cart:refresh', function () { setTimeout(initAll, 50); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();

  window.VIP_DELIVERY = { __loaded: true, init: initAll, attributeKey: attrKey, options: options };
})();
